<template>
  <el-button-group class="table-view-mode-toggle" aria-label="列表字段视图">
    <el-button
        :aria-pressed="!isFullView"
        :disabled="saving || !isFullView"
        :type="!isFullView ? 'primary' : 'default'"
        size="small"
        @click="changeMode('COMPACT')"
    >精简字段</el-button>
    <el-button
        :aria-pressed="isFullView"
        :disabled="saving || isFullView"
        :type="isFullView ? 'primary' : 'default'"
        size="small"
        @click="changeMode('FULL')"
    >完整字段</el-button>
  </el-button-group>
</template>

<script>
import {isTableViewFull, saveTableViewMode} from '@/services/tableViewPreferences'

/** 当前账号在一个业务列表上的完整/精简字段切换入口。 */
export default {
  name: 'TableViewModeToggle',
  props: {
    viewKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      saving: false,
    }
  },
  computed: {
    isFullView() {
      return isTableViewFull(this.viewKey)
    },
  },
  methods: {
    async changeMode(viewMode) {
      if (this.saving || (viewMode === 'FULL') === this.isFullView) return
      this.saving = true
      try {
        await saveTableViewMode(this.viewKey, viewMode)
        this.$message.success(viewMode === 'FULL' ? '已切换为完整字段，并会记住此设置。' : '已切换为精简字段，并会记住此设置。')
      } catch (error) {
        this.$message.error(error.message || '保存列表字段视图失败，请稍后重试。')
      } finally {
        this.saving = false
      }
    },
  },
}
</script>
